import React from "react";
import { TooltipContent } from "./components/InfoTooltip";

// Homepage card tooltips: what each number means, and what is left out.

export const ERROR_RATE_INFO = (
  <TooltipContent
    intro="Error rate in the selected period."
    items={[
      "Tag Monitor: the percentage of tag calls that failed.",
      "DataLayer Guard: the number of errors found as a percentage of the dataLayer events checked.",
    ]}
  />
);


export const QUICK_ACTIONS_INFO = (
  <TooltipContent intro="Suggested fixes and tasks based on your most recent data." />
);

export const TAG_MONITORED_INFO =
  "Tag calls without errors in the selected period. Based on sampled size set in GTM. ";

export const TAG_EVENTS_FIRED_INFO =
  "Number of different events that fired tags in the selected period.";

export const TAG_RECENT_ERRORS_INFO =
  "Tag calls with errors in the selected period.";

export const TAG_EVENTS_CHART_INFO =
  "Failed and successful tag calls shown based on the selected time range. ";

export const TOP_ERRORS_INFO = (
  <TooltipContent
    intro="The tags with the highest error % in the selected period, per event."
    note=""
  />
);

export const INACTIVE_TAGS_INFO = (
  <TooltipContent
    intro="Based on the last 8 days (the date filter doesn't apply here). sorted by:"
    items={[
      " 1. Tags as configured in Tag Volume alerting.",
      " 2. Tags that went inactive the most recent.",
    ]}
    // note="Tags that didn't fire at all in the last 8 days, and tags excluded from monitoring, are not shown."
  />
);

export const ANOMALIES_INFO = (
  <TooltipContent
    intro="An anomaly is an hour in which a tag's volume was well outside its expected range."
    // note="Only available for client-side tags. "
  />
);

export const DATALAYER_MONITORED_INFO =
  "The number of dataLayer events checked in the selected period, minus the errors found.";

export const DATALAYER_RECENT_ERRORS_INFO =
  "Errors DataLayer Guard found in the selected period. One dataLayer event can have more than one error. Failed scenario steps are not counted.";

export const DATALAYER_CHART_INFO =
  "Errors per event, per day, or per hour for Today and Yesterday. Click a legend item to show or hide it.";

export const DATALAYER_TOP_ERRORS_INFO = (
  <TooltipContent
    intro="The 5 most recent errors in the selected period"
    // note="Failed scenario steps are not counted."
  />
);


